import groceryapi from "../../../services/grocery";

export const fetchProductsApi = async () => {
  const response = await groceryapi.get("Products/no-paginate");
  return response.data;
};

export const fetchGroceryListsApi = async (page = 1, size = 10) => {
  const response = await groceryapi.get(`GroceryLists/by-branch?page=${page}&size=${size}`);
  return response.data;
};

export const saveGroceryListApi = async (payload) => {
  const response = await groceryapi.post("GroceryLists/with-items", payload);
  return response.data;
};

export const fetchGroceryListItemsApi = async (listId) => {
  const response = await groceryapi.get(`GroceryListItems/by-list/${listId}`);
  return response.data;
};

export const updateGroceryListItemApi = async (id, payload) => {
  const response = await groceryapi.put(`GroceryListItems/${id}`, payload);
  return response.data;
};

export const deleteGroceryListItemApi = async (id) => {
  const response = await groceryapi.delete(`GroceryListItems/${id}`);
  return response.data;
};

export const addGroceryListItemApi = async (payload) => {
  const response = await groceryapi.post("GroceryListItems", payload);
  return response.data;
};

export const updateGroceryListApi = async (id, payload) => {
  const response = await groceryapi.put(`GroceryLists/${id}`, payload);
  return response.data;
};

export const exportManagerPdfApi = async (params) => {
  const response = await groceryapi.get("GroceryLists/export/manager", {
    params,
    responseType: "blob"
  });
  return response.data;
};

export const printBranchPdfApi = async (params) => {
  const response = await groceryapi.get("GroceryLists/print", {
    params,
    responseType: "blob"
  });
  return response.data;
};
